import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import "./twb.css";

const Oliveagro = (props) => {
  const { className } = props;

  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const closeBtn = (
    <button className='close' onClick={toggle}>
      &times;
    </button>
  );

  return (
    <div>
      <button className='button' onClick={toggle}>
        See the project
      </button>
      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle} close={closeBtn}>
          Modal title
        </ModalHeader>
        <ModalBody className='modalBody'>
          <img
            src='https://res.cloudinary.com/elijjaaahhhh/image/upload/v1618402166/FireShot_Capture_253_-_Multi_Device_Website_Mockup_Generator_-_techsini.com_snwfqq.png'
            alt='img'
          />
          <h2>Oliveagro</h2>
          <div className='tag-body-single'>
            <div className='tags'>React</div>
            <div className='tags'>Redux</div>
            <div className='tags'>Node</div>
          </div>
          <p>
            This is a website built with React/Redux(frontend) and
            Node(backend). I worked on the frontend by integrating the required
            api's from the backend. It is a platform where vendors register in
            other to display their goods for propective clients to connect with
            them and buy
          </p>
          <div className='tag-body-live'>
            <div className='tag one'>
              <a href='https://oliveagro.org/' target='_blank'>
                See live
              </a>
            </div>
            <div className='tag two'>
              <a href='#work' target='_blank'>
                Locked
              </a>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Oliveagro;
